import { useQueryClient } from '@tanstack/react-query';

import usePageName from 'services/menu/usePageName';
import { useSensorList } from 'services/sensor';
import { useCurrentUser } from 'services/auth';
import { useToggle, useInterval } from 'utils/hooks';

import PHeader from 'components/shared/PageHeader';
import { AutoRefreshButton } from 'components/common/AutoRefreshButton';

import SensorPicker from './SensorPicker';
import Bookmarks from './Bookmarks';
import Notifications from './Notifications';
import UserMenu from './UserMenu';
import { LicenseExpiryCallout } from './LicenseExpiryCallout';

const AUTO_REFRESH_INTERVAL = 1000 * 60 * 60;

const ExecSummaryAutoRefresh = () => {
  const queryClient = useQueryClient();
  const autoRefresh = useToggle(false);

  useInterval(() => queryClient.invalidateQueries(), autoRefresh.isOn ? AUTO_REFRESH_INTERVAL : null);

  return (
    <AutoRefreshButton
      isOn={autoRefresh.isOn}
      onClick={autoRefresh.toggle}
      tooltipOn="Disable auto-refresh every 60 minutes"
      tooltipOff="Enable auto-refresh every 60 minutes"
      tooltipPlacement="bottom"
    />
  );
};

const PageHeader = () => {
  const { category, categoryName, pageName, description } = usePageName() as unknown as {
    category: string;
    categoryName: string;
    pageName: string;
    description: string;
  };
  const { user } = useCurrentUser();
  const { sensorList } = useSensorList() as unknown as { sensorList: any[] };

  const title = pageName || categoryName;
  const isExecSummary = pageName === 'Executive Summary';

  return (
    <PHeader
      title={title}
      description={description}
      titleAction={isExecSummary ? <ExecSummaryAutoRefresh /> : undefined}
    >
      <LicenseExpiryCallout />
      {!['settings', 'api', 'usage'].includes(category) && sensorList && (
        <>
          <SensorPicker />
          <Bookmarks />
        </>
      )}
      {user && user.id > -1 && <Notifications />}
      <UserMenu />
    </PHeader>
  );
};

export default PageHeader;
